module.exports = __webpack_public_path__ + "static/media/6.ee0499cb.jpg";